module.exports = __webpack_public_path__ + "img/xjzg.bec09384.png";